import BettingContainer from '@/components/BettingContainer';
import Sidebar from '@/components/common/Sidebar';
import Header from '@/components/Header';
import Marquee from '@/components/Marquee';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

const GameLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return (
    <div className="bg-primary">
      <Header onMenuClick={() => setIsSidebarOpen(true)} />
      <Marquee type="mobile" />
      <div className="flex xl:mt-1 xl:pr-[5px]">
        <Sidebar isOpen={isSidebarOpen} onToggle={() => setIsSidebarOpen(false)} />

        <main className="flex-1 overflow-hidden mb-14 md:mb-0 222">
          <Outlet />
        </main>
        <BettingContainer />
      </div>
      {/* Footer */}
      {/* <Footer /> */}
    </div>
  );
};

export default GameLayout;
